import script from "./hct-setting.vue?vue&type=script&setup=true&lang=js"
export * from "./hct-setting.vue?vue&type=script&setup=true&lang=js"

import "./hct-setting.vue?vue&type=style&index=0&id=39035266&scoped=true&lang=scss"

import exportComponent from "E:\\a-project\\hct-element\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39035266"]])

export default __exports__